export default {
  // 页面/Tab 标签
  供应商文件: "供应商文件",
  供应商帐号: "供应商帐号",

  // 供应商列表
  供应商编号: "供应商编号",
  代理商: "代理商",
  生产商: "生产商",

  // 企业文件/物料文件
  企业文件: "企业文件",
  物料文件: "物料文件",
  通知供应商上传文件: "通知供应商上传文件",
  添加物料: "添加物料",

  // 物料项相关
  物料编号: "物料编号",
  物料名称: "物料名称",
  编辑物料: "编辑物料",
  删除物料: "删除物料",
  确认是否删除此物料: "确认是否删除此物料？",

  // 账号审核弹窗
  供应商账号审核: "供应商账号审核",
  审核成功: "审核成功",

  // 文件审核弹窗
  审批意见: "审批意见",
  请选择审批意见: "请选择审批意见",
  通过: "通过",
  驳回: "驳回",
  意见说明: "意见说明",
  请填写意见说明: "请填写意见说明",
  文件审核: "文件审核",

  // 添加/编辑物料弹窗
  "抱歉，无法查询到该物料编号，请重新查询输入。":
    "抱歉，无法查询到该物料编号，请重新查询输入。",
  修改物料: "修改物料",
  添加物料弹窗: "添加物料",
  根据物料编码搜索: "根据物料编码搜索",
  请输入物料编码: "请输入物料编码",
  物料编码: "物料编码",
  物料名称必填: "请输入物料名称",

  // 账号操作按钮
  禁用成功: "禁用成功",
  禁用账号: "禁用账号",
  确定要禁用该账号吗: "确定要禁用该账号吗？",
  禁用: "禁用",
  解禁成功: "解禁成功",
  解禁账号: "解禁账号",
  确定要解禁该账号吗: "确定要解禁该账号吗？",
  解禁: "解禁",
  审核按钮: "审核",

  // 表格列名
  序号: "序号",
  注册邮箱: "注册邮箱",
  姓名: "姓名",
  所属部门: "所属部门",
  电话号码: "电话号码",
  注册状态: "注册状态",
  最近登录时间: "最近登录时间",
  文件名称: "文件名称",
  文件有效期至: "文件有效期至",
  文件状态: "文件状态",
  最新上传时间: "最新上传时间",
  上传用户: "上传用户",
  最新版本: "最新版本",
  上一版本: "上一版本",

  // 操作相关
  驳回原因: "驳回原因",
  查看驳回原因: "查看驳回原因",
  提醒对方: "提醒对方",
  审核操作: "审核",
  更新文件: "更新文件",
  下载: "下载",

  // 成功提示消息
  发送成功: "发送成功",
  保存成功: "保存成功",
  修改成功: "修改成功",
  删除成功: "删除成功",
  提交成功: "提交成功",
  通知发送成功: "通知发送成功",
  添加成功: "添加成功",

  // 其他
  添加: "添加",
  搜索: "搜索",

  // AllTab 全部列表
  供应商阶段: "供应商阶段",
  供应商名称中文: "供应商名称 (中文)",
  供应商名称英文: "供应商名称 (英文)",
  供应商名称表单: "供应商名称",
  工厂: "工厂",
  物料类别: "物料类别",
  采购类型: "采购类型",
  企业类型: "企业类型",
  已注册账号数量: "已注册账号数量",
  已添加物料数量: "已添加物料数量",
  待审核文件数量: "待审核文件数量",
  负责人表格: "负责人",
  全部列表: "全部列表",
  生产性物料: "生产性物料",
  非生产性物料: "非生产性物料",

  // FrozenTab 冻结模块
  冻结列表: "冻结列表",
  申请冻结: "申请冻结",
  供应商信息: "供应商信息",
  冻结类型: "冻结类型",
  禁止供货工厂: "禁止供货工厂",
  禁止供货物料: "禁止供货物料",
  冻结原因: "冻结原因",
  相关证明文件: "相关证明文件",
  解冻原因: "解冻原因",
  申请类型: "申请类型",
  申请状态: "申请状态",
  表单编号: "表单编号",
  申请原因: "申请原因",
  申请时间: "申请时间",
  申请人: "申请人",
  重新提交: "重新提交",
  解冻申请: "解冻申请",
  冻结申请已提交: "冻结申请已提交",
  解冻申请已提交: "解冻申请已提交",
  审批成功: "审批成功",
  审批中: "审批中",
  已通过: "已通过",
  已驳回: "已驳回",
  供应商冻结: "供应商冻结",
  物料冻结: "物料冻结",

  // Tab 标签
  全部: "全部",
  注册: "注册",
  评估: "评估",
  准入: "准入",
  冻结: "冻结",
  黑名单: "黑名单",

  // RegisteredTab 注册列表
  注册列表: "注册列表",
  代注册: "代注册",
  邮箱邀请: "邮箱邀请",
  共: "共",
  条数据: "条数据",
  删除确认: "删除确认",
  确定要删除供应商: "确定要删除供应商",
  吗: "吗",
  确认: "确认",
  取消: "取消",
  邀请人: "邀请人",
  请输入供应商名称: "请输入供应商名称",
  请输入邀请人名字: "请输入邀请人名字",
  请选择注册状态: "请选择注册状态",
  注册来源: "注册来源",
  联系人: "联系人",
  联系电话: "联系电话",
  邀请日期: "邀请日期",
  操作: "操作",
  编辑: "编辑",
  查看: "查看",
  邀请子账号: "邀请子账号",

  // RegistrationModal 相关
  供应商注册信息表: "供应商注册信息表",
  编辑供应商信息: "编辑供应商信息",
  审核供应商信息: "审核供应商信息",
  查看供应商信息: "查看供应商信息",
  保存: "保存",
  关闭: "关闭",
  获取国家列表失败: "获取国家列表失败",
  已自动填充供应商信息: "已自动填充供应商信息",
  获取供应商详情失败请手动填写: "获取供应商详情失败,请手动填写",
  加载省份列表失败: "加载省份列表失败",
  加载供应商详情失败: "加载供应商详情失败",
  代注册成功: "代注册成功!",
  编辑成功: "编辑成功!",
  请完善必填项: "请完善必填项",

  // BankInfoTable 相关
  公户: "公户",
  私户: "私户",
  银行国家: "银行国家",
  银行账户类型: "银行账户类型",
  开户行名称: "开户行名称",
  开户行行号: "开户行行号",
  银行账号: "银行账号",
  SWIFT代码: "SWIFT代码",
  开户人单位: "开户人/单位",
  SAP不存在提示: "提示：检测到SAP不存在当前开户行信息",
  请选择: "请选择",

  // EmailInvite 相关
  使用默认邮件模板: "使用默认邮件模板",
  邮箱邀请发送成功: "邮箱邀请发送成功!",
  发送邮箱邀请失败请重试: "发送邮箱邀请失败，请重试",

  // query.tsx 表单配置相关
  供应商名称: "供应商名称",
  供应商邮箱: "供应商邮箱",
  发送: "发送",
  供应商基本信息: "供应商基本信息",
  地址信息: "地址信息",
  供货信息: "供货信息",
  注册人信息: "注册人信息",
  银行信息: "银行信息",
  证照文件: "证照文件",
  请输入供应商名称或从下拉选择: "请输入供应商名称或从下拉选择",
  请输入生产商名称或从下拉选择: "请输入生产商名称或从下拉选择",
  请输入: "请输入",
  请选择国家: "请选择国家",
  请选择省份城市: "请选择省份/城市",
  请输入省份城市: "请输入省份/城市",
  请输入邮编: "请输入",
  请输入街道: "请输入",
  请输入经营范围: "请输入",
  请输入姓氏: "请输入",
  请输入名字: "请输入",
  请选择部门: "请选择部门",
  请输入电话号码: "请输入",
  请输入邮箱: "请输入",
  邮箱格式不正确: "邮箱格式不正确",
  审核通过: "审核通过",
  请输入意见说明: "请输入...",
  开始日期: "开始日期",
  结束日期: "结束日期",
  邮件主题: "邮件主题",
  请输入邮件主题: "请输入邮件主题",
  邀请文本: "邀请文本",
  请输入邮请文本: "请输入邮请文本",
  请输入或选择生产商名称: "请输入或选择生产商名称",
  请选择营业有效期: "请选择营业有效期",
  请输入统一社会信用代码商业登记号: "请输入统一社会信用代码/商业登记号",
  请选择企业类型: "请选择企业类型",
  请选择语言: "请选择语言",
  营业执照: "营业执照",
  银行资料: "银行资料",
  开户证明: "开户证明",
  收款授权信: "收款授权信",
  其他: "其他",

  // formConfig2.tsx 相关
  下一步: "下一步",
  上一步: "上一步",
  暂存: "暂存",
  提交: "提交",
  供应商设置: "供应商设置",
  供应商编码: "供应商编码",
  二级物料类别: "二级物料类别",
  物料目的: "物料目的",
  是否为GMP: "是否为GMP",
  供应商等级: "供应商等级",
  采购信息: "采购信息",
  采购小组: "采购小组",
  货币: "货币",
  付款方式: "付款方式",
  付款条约: "付款条约",
  国际贸易条款: "国际贸易条款",
  财务信息: "财务信息",
  科目小组: "科目小组",
  科目编号: "科目编号",
  其他合作信息: "其他合作信息",
  OA地址: "OA地址",
  PI发票方: "PI发票方",
  准入评估结果: "准入评估结果",
  查看评估结果: "查看评估结果",
  审核意见: "审核意见",
  同意: "同意",

  // formConfig2 验证消息相关
  请选择采购小组: "请选择采购小组",
  请选择货币: "请选择货币",
  请选择付款方式: "请选择付款方式",
  请选择付款条约: "请选择付款条约",
  请选择国际贸易条款: "请选择国际贸易条款",
  请选择科目小组: "请选择科目小组",
  请选择科目小组以自动填充科目编号: "请选择科目小组以自动填充科目编号",
  请选择工厂: "请选择工厂",
  请选择物料类别: "请选择物料类别",
  请选择二级物料类别: "请选择二级物料类别",
  请选择物料目的: "请选择物料目的",
  请选择是否为GMP: "请选择是否为GMP",

  // formConfig2 选项相关
  Yes: "Yes",
  No: "No",
  生产物料: "生产物料",
  非生产物料: "非生产物料",
  API: "API",
  "辅料（Excipient）": "辅料（Excipient）",
  包材: "包材",
  RLD: "RLD",
  工程建设: "工程建设",
  "设备/设施/仪器": "设备/设施/仪器",
  MRO: "MRO",
  行政物资: "行政物资",
  IT物资: "IT物资",
  外包服务: "外包服务",
  "A类物料（战略物料）": "A类物料（战略物料）",
  "B、C类物料+AF委外采购产品": "B、C类物料+AF委外采购产品",
  OEM客户专用物料: "OEM客户专用物料",
  一般供应商: "一般供应商",
  重点供应商: "重点供应商",
  战略供应商: "战略供应商",
  "C01 Dir.Matl-Plant 工厂-生产物料": "C01 Dir.Matl-Plant 工厂-生产物料",
  "C02 Indir.Matl-MRO 工厂-易耗品": "C02 Indir.Matl-MRO 工厂-易耗品",
  "C03 Indir.Matl-Other 工厂-固定资产/项目":
    "C03 Indir.Matl-Other 工厂-固定资产/项目",
  "C04 Dir.Matl-Other 研发-小试物料": "C04 Dir.Matl-Other 研发-小试物料",
  "C05 Dir.Matl-For E5 工厂-生产物料": "C05 Dir.Matl-For E5 工厂-生产物料",
  "C06 Idir.Matl-R&D 研发-固定资产/项目":
    "C06 Idir.Matl-R&D 研发-固定资产/项目",
  "C07 Dir.Matl-Scale-up 研发-中试物料": "C07 Dir.Matl-Scale-up 研发-中试物料",
  HKD: "HKD",
  CNY: "CNY",
  EUR: "EUR",
  USD: "USD",
  GBP: "GBP",
  TWD: "TWD",
  AUD: "AUD",
  JPY: "JPY",
  VND: "VND",
  CHF: "CHF",
  TT: "TT",
  Cheque: "Cheque",
  Other: "Other",
  "Advance payment": "Advance payment",
  "Cash on Delivery": "Cash on Delivery",
  "Advance payment by progress, refer to remark":
    "Advance payment by progress, refer to remark",
  "Deposit and progress payment, refer to remark":
    "Deposit and progress payment, refer to remark",
  "L/C 120 days": "L/C 120 days",
  "L/C 15 days": "L/C 15 days",
  "L/C 30 days": "L/C 30 days",
  "L/C 45 days": "L/C 45 days",
  "L/C 60 days": "L/C 60 days",
  "L/C 75 days": "L/C 75 days",
  "L/C 90 days": "L/C 90 days",
  "L/C at sight": "L/C at sight",
  "30 days from month end": "30 days from month end",
  "35 days from month end": "35 days from month end",
  "45 days from month end": "45 days from month end",
  "Net due on 7 days": "Net due on 7 days",
  "Net due on 14 days": "Net due on 14 days",
  "Net due on 15 days": "Net due on 15 days",
  "Net due on 30 days": "Net due on 30 days",
  "Net due on 35 days": "Net due on 35 days",
  "Net due on 40 days": "Net due on 40 days",
  "Net due on 45 days": "Net due on 45 days",
  "Net due on 60 days": "Net due on 60 days",
  "Net due on 75 days": "Net due on 75 days",
  "Net due on 85 days": "Net due on 85 days",
  "Net due on 90 days": "Net due on 90 days",
  "Net due on 120 days": "Net due on 120 days",
  "Cash against documents": "Cash against documents",
  "Costs and freight": "Costs and freight",
  "Costs, insurance & freight": "Costs, insurance & freight",
  "Carriage and insurance paid to": "Carriage and insurance paid to",
  "Carriage paid to": "Carriage paid to",
  "Delivered at frontier": "Delivered at frontier",
  "Delivered Duty Paid": "Delivered Duty Paid",
  "Delivered Duty Unpaid": "Delivered Duty Unpaid",
  "Delivered ex quay (duty paid)": "Delivered ex quay (duty paid)",
  "Delivered ex ship": "Delivered ex ship",
  "Ex Works": "Ex Works",
  "Free Alongside Ship": "Free Alongside Ship",
  "Free Carrier": "Free Carrier",
  "Free house": "Free house",
  "Free on board": "Free on board",
  "Not Free": "Not Free",
  "BF-Production Material Vendor": "BF-Production Material Vendor",
  "BF-Production Material Agent": "BF-Production Material Agent",
  "BF-Non-production Vendor": "BF-Non-production Vendor",
  "BF-Vendor (FI Only)": "BF-Vendor (FI Only)",
  "BF-Intercompany Vendor": "BF-Intercompany Vendor",
  "BF-Equipment Vendor": "BF-Equipment Vendor",
  "E1 Bright Future": "E1 Bright Future",
  "E2 BF Chinese Medicine": "E2 BF Chinese Medicine",
  "E4 SumaUS": "E4 SumaUS",
  "E5 SumaHK": "E5 SumaHK",

  // 必填字段验证提示
  请输入供应商编号: "请输入供应商编号",
  "请选择供应商名称（中文）": "请选择供应商名称（中文）",
  "请选择供应商名称（英文）": "请选择供应商名称（英文）",
  请选择采购类型: "请选择采购类型",
  请选择是否为首次采购: "请选择是否为首次采购",
};
